import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-splash-screen',
  styleUrls: ['splash-screen.component.scss'],
  template: `
    <section class="splash-screen" #splashScreen>
      <div class="splash-box">
        <!-- If logo changes, don't forget to update the background-image in the SCSS, as well. -->
        <img src="../assets/img/nymbl_logo.svg" alt="" class="static-logo" />
      </div>
    </section>
  `
})
export class SplashScreenComponent implements AfterViewInit {
  @ViewChild('splashScreen') splashScreen: ElementRef;
  @Input() maxWidth: string = '';
  @Input() maxHeight: string = '';

  ngAfterViewInit(): void {
    this.splashScreen?.nativeElement?.style.setProperty(
      '--initial-width',
      this.maxWidth
    );
    this.splashScreen?.nativeElement?.style.setProperty(
      '--initial-height',
      this.maxHeight
    );
  }
}
